import { Check, Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '~/components/ui/dropdown-menu';

const LANGUAGE_KEY = 'I18N_LANGUAGE';
const LANGUAGES: { code: string; label: string }[] = [
	{ code: 'el', label: 'Ελληνικά' },
	{ code: 'en', label: 'English' }
];

/** EL/EN language switcher. Persists the choice to localStorage (legacy key, shared
 * with the existing admin) and applies it via react-i18next. */
export function LanguageMenu() {
	const { i18n, t } = useTranslation();
	const active = i18n.language;

	const change = (code: string) => {
		void i18n.changeLanguage(code);
		try {
			localStorage.setItem(LANGUAGE_KEY, code);
		} catch {
			/* ignore quota/availability */
		}
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon-sm" aria-label={t('shell.language.label')}>
					<Languages size={16} />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="min-w-[160px]">
				{LANGUAGES.map(lang => (
					<DropdownMenuItem key={lang.code} onSelect={() => change(lang.code)}>
						<span className="flex-1">{lang.label}</span>
						{active === lang.code && <Check size={14} className="text-brand-subtle-fg" />}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
